import { Motorista } from "../../models/Motorista.ts";
import { api } from "../ModuloGerenciador/UrlPadrao";
import { ResponseApi } from "./Viagens.ts";

export interface BuscarRelatorioKmProps {
	token: string;
	dataInicio: string;
	dataFinal: string;
	pontoKm: number;
	pontoViagem: number;
}

export interface RelatorioKm {
	classificacao?: string;
	nome: string;
	documento: string;
	tipo?: string;
	kmFeitos: number;
	viagensFeitas: number;
	pontos: number;
	placa?: string;
}

export interface RelatorioKmResponse extends ResponseApi {
	motoristas: RelatorioKm[];
	proprietarios: RelatorioKm[];
}

export const buscarRelatorioKm = async ({
	token,
	dataInicio,
	dataFinal,
	pontoKm,
	pontoViagem,
}: BuscarRelatorioKmProps): Promise<RelatorioKmResponse> => {
	const response = await api.get(
		`motorista/relatorio-km/${dataInicio}/${dataFinal}/${pontoKm}/${pontoViagem}`,
		{
			headers: {
				Authorization: token,
			},
		},
	);

	return response.data;
};

export const getMotorista = async ({
	token,
}: {
	token: string;
}): Promise<Motorista[]> => {
	return api.get("motorista", {
		headers: {
			Authorization: token,
		},
	});
};
